
export default (text, type) => {
    return new Blob([text], {
        type: type || 'text/plain'
    });
};
